var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentInstruction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 2H3C2.44444 2 2 2.44444 2 3V21C2 21.4444 2.44444 22 3 22H21C21.4444 22 22 21.4444 22 21V3C22 2.44444 21.4444 2 21 2ZM8.66753 6.44531H6.44531V8.66753H8.66753V6.44531ZM17.5553 6.44531H10.8887V8.66753H17.5553V6.44531ZM17.5553 10.8887H10.8887V13.1109H17.5553V10.8887ZM10.8887 15.333H17.5553V17.5552H10.8887V15.333ZM6.44531 10.8887H8.66753V13.1109H6.44531V10.8887ZM8.66753 15.333H6.44531V17.5552H8.66753V15.333ZM4.22168 19.7772H19.7772V4.22168H4.22168V19.7772Z",
    fill: "#264F3F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentInstruction);
export default __webpack_public_path__ + "static/media/payment-instruction.1de54a8b.svg";
export { ForwardRef as ReactComponent };